

const API_URL = '/prices.json';

const apiCall = () => {
  return fetch(API_URL).then(response => {
      return response.json().then(json => {
          if (!response.ok) {
              return Promise.reject(json);
          }

          return json
      })
  })
};


export const fetchPrices = () => {
    return apiCall();
};



// WEBPACK FOOTER //
// ./src/api/price.js